import { Grid } from 'jrgrid';
import { pageEOneUpdates } from '../api';
import Navbar from '../../../components/Navbar';
import { eOneColumns, filterButtonsEOne } from '../utils';
import React from 'react';
import { Loader } from '../../../components/Loader';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export const RequestEOneErrorsPage = (props: any) => {
  const [refresh, setRefresh] = React.useState(false);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));

  const renderEOneErrorsGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid..' />;
    } else {
      // let filter = [];
      const filter = [
        {
          id: 'updateStatus',
          isLike: true,
          operand: 'and',
          type: 'string',
          value: '%error%',
        },
        {
          id: 'updateType',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'A',
        },
        // {
        //   id: 'toDeptId',
        //   type: 'string',
        //   operand: 'and',
        //   isLike: false,
        //   value: `${user.currentRole.departmentId}`,
        // },
      ];

      return (
        <Grid
          amount={20}
          columns={eOneColumns}
          query={pageEOneUpdates}
          queryName='pageEOneUpdates'
          defaultSortField='updateId'
          globalFilters={/* gridFilter ? [gridFilter, ...filter] : [...filter] */ filter}
        />
      );
    }
  };

  return (
    <div>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={8}>
            {/* {filterButtonsEOne.map((item, index) => {
              return (
                <Button
                  key={index}
                  className='mt-3 mb-3 ml-2'
                  onClick={() => {
                    setGridFilter(item.filter);
                  }}>
                  {item.title}
                </Button>
              );
            })} */}
          </Col>
          <Col md={4}>
            <h3 className='mt-3 mb-3 ml-2 mr-2 float-right'>EOne Errors</h3>
          </Col>
        </Row>
        {renderEOneErrorsGrid()}
      </div>
    </div>
  );
};
